









































import { mapActions, mapState } from "vuex";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";

import { Prop, Vue, Component } from "vue-property-decorator";
import modalState from "@/common/store/modules/modalState";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";

@Component({
  components: {
    ModalMain,
    ButtonMain,
    IconUserImage
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class ModalSelectSendUser extends Vue {
  @Prop({ type: [Object, Boolean], default: false }) modalSelectSendUserData!:
    | any
    | boolean;

  get icon() {
    return this.modalSelectSendUserData.sendTo.icon.medium;
  }

  get name() {
    return this.modalSelectSendUserData.sendTo.name;
  }

  get comment() {
    return this.modalSelectSendUserData.sendTo.comment;
  }

  get url() {
    return this.modalSelectSendUserData.sendTo.url;
  }

  get profileIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 80 : 144;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  closeModal() {
    modalState.changeModal("");
  }
}
